import OldBaseFormMediator from './OldBaseFormMediator'
import messageResource from '../messageResource'
import $ from 'jquery'
import _ from 'underscore'
import TTDetailReportEditFormConfigController from './edit_config_controller/ttDetail/TTDetailReportEditFormConfigController'
import TTDetailCSVPreviewGenerator from './preview/csv/ttdetail/TTDetailCSVPreviewGenerator'
import TTDetailHTMLPreviewGenerator from './preview/html/ttdetail/TTDetailHTMLPreviewGenerator'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'

export default function TTDetailFormMediator(){}

TTDetailFormMediator.prototype = _.create(OldBaseFormMediator.prototype);

TTDetailFormMediator.prototype.init = function( config ) {
    OldBaseFormMediator.prototype.init.call(this, config);
    this._showJoinedCommentsNote(config.reportParameters.joinCommentsByTask);
    return this;
};

TTDetailFormMediator.prototype.initParamsStringBuilder = function ( config )
{
    return new ATReportParamsStringBuilder({
        data: {
            cpList: config.cpList,
            users: config.users,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    })
};

TTDetailFormMediator.prototype.initEditConfigController = function ( config ) {
    const self = this;
    return new TTDetailReportEditFormConfigController().init(
        {
            panelId: "mainContainer",
            reportAuthorizationInfo: config.reportAuthorizationInfo,
            reportParameters: config.reportParameters,
            cpList: config.cpList,
            customersWithMaIds: config.customersWithMaIds,
            projectsWithMaIds: config.projectsWithMaIds,
            users: config.users,
            manageableUsersIds: config.manageableUserIds,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            changeCallback: function(){ self.changeParametersCallback()}
        } )
};

TTDetailFormMediator.prototype.initCsvGenerator = function(){
    return new TTDetailCSVPreviewGenerator().init();
};

TTDetailFormMediator.prototype.initHtmlGenerator = function() {
    return new TTDetailHTMLPreviewGenerator().init();
};

TTDetailFormMediator.prototype.changeParametersCallback = function(){
    OldBaseFormMediator.prototype.changeParametersCallback.call(this);
    if (this.configController)
        this._showJoinedCommentsNote(this.configController.getJoinCommentsByTask());
};

TTDetailFormMediator.prototype._createJoinedCommentsNote = function() {
    const element = $(document.createElement("div"));
    element.addClass("joinCommentsNote");
    element.html(messageResource.getMessage("reports.comments_report.form.format.joined_comments_note"));
    $(".reportPreviewArea").append(element);
    return element;

};
TTDetailFormMediator.prototype._showJoinedCommentsNote = function( isShowed ) {
    if (!this.commentsNoteElement){
        this.commentsNoteElement = this._createJoinedCommentsNote();
    }
    const element = this.commentsNoteElement;
    if (isShowed){
        element.removeClass("hide");
    } else {
        element.addClass("hide");
    }
};



// WEBPACK FOOTER //
// ./web/js/reports/TTDetailFormMediator.js